export const newCompany = {
	pageTitle: {
		sv: "Starta företag",
	},
	description: {
		sv: "Det är enkelt att starta nytt företag med Svea Bank. Skicka in din ansökan och när företaget är registrerat blir du automatiskt företagskund.",
	},
	headerLink: {
		sv: "https://www.svea.com/sv-se/foretag/f%C3%B6retagsbanken/starta-f%C3%B6retag",
	},
	headerLinkText: {
		sv: "Mer om Starta bolag",
	},
	nationalId: {
		sv: "Personnummer",
	},
	getPerson: {
		sv: "Hämta uppgifter",
	},
	shareholder: {
		sv: "Aktieägare/stiftare",
	},
	beneficialOwner: {
		sv: "Verklig huvudman",
	},
	processModalInfoHeading1: {
		sv: "Du ansöker",
	},
	processModalInfoHeading2: {
		sv: "Du betalar in",
	},
	processModalInfoHeading3: {
		sv: "Vi skapar bankintyg",
	},
	processModalInfoHeading4: {
		sv: "Du är igång med företaget!",
	},
	processModalInfoText1: {
		sv: "Ansök digitalt hos oss och på Verksamt.se. Lämna samma uppgifter oavsett var du börjar.",
	},
	processModalInfoText2: {
		sv: "Vi meddelar när du ska betala in företagets aktiekapital (minst 25 000 kr) och avgift för bankintyg (1 995 kr).",
	},
	processModalInfoText3: {
		sv: "Vi skickar bankintyget till Bolagsverket så att ditt företag får organisationsnummer och registreras.",
	},
	processModalInfoText4: {
		sv: "När företaget registrerats blir du kund hos oss och får tillgång till ditt aktiekapital på företagskontot.",
	},
	summary: {
		heading: {
			sv: "Starta bolag - dina inskickade uppgifter",
		},
		returnLink: {
			sv: "Tillbaka till Välj företag",
		},
		applicationStarted: {
			sv: "Ansökan startad {0}",
		},
		bodyText: {
			sv: "Här är uppgifterna från din ansökan om att starta bolag. Du ska lämna exakt samma information till Verksamt.se",
		},
	},
	companyInfo: {
		heading: {
			sv: "Företagsuppgifter",
		},
		addressHeading: {
			sv: "Företagets adress",
		},
		contactHeading: {
			sv: "Kontaktuppgifter i ärendet",
		},
		namesHeading: {
			sv: "Namnförslag",
		},
		orgNumber: {
			sv: "Organisationsnummer",
		},
		description: {
			sv: "Fyll i uppgifter om företaget och verksamheten.",
		},
		coAddress: {
			sv: "C/o-adress",
		},
		address: {
			sv: "Adress",
		},
		zip: {
			sv: "Postnummer",
		},
		city: {
			sv: "Ort",
		},
		seat: {
			sv: "Säte",
		},
		selectResidence: {
			sv: "Välj säte",
		},
		foundingDate: {
			sv: "Datum när företaget bildades",
		},
		name: {
			sv: "För- och efternamn",
		},
		email: {
			sv: "Mejladress",
		},
		confirmEmail: {
			sv: "Bekräfta mejladress",
		},
		countryCode: {
			sv: "Landskod",
		},
		phone: {
			sv: "Telefonnummer",
		},
		nameSuggestions: {
			sv: "Namnförslag",
		},
		addNameSuggestions: {
			sv: "Lägg till fler namnförslag",
		},
		businessDescription: {
			sv: "Verksamhetsbeskrivning",
		},
		businessDescriptionText: {
			sv: "Beskriv den kommande verksamheten i företaget",
		},
		sni: {
			sv: "Bransch",
		},
		sniText: {
			sv: "Sök efter den bransch som bäst förklarar företagets verksamhet. Lägg till minst 1 branschkod (SNI-kod).",
		},
		helpText1: {
			sv: `
**Företagets adress**  
Om en privatperson ska ansvara för företagets post 
ska du skriva personens förnamn och efternamn i fältet 
C/o, exempelvis C/o Anna Andersson. Detta för att posten 
ska komma fram till företaget.`,
		},
		helpText2: {
			sv: `
**Namnförslag**  
Du behöver välja ett företagsnamn som beskriver din företaget på rätt sätt. Det är viktigt att 
namnet är unikt och inte liknar andra företag, beskrivande för din verksamhet, lätt 
att uttala och komma ihåg.  
&nbsp;  
Företagsnamnet ska innehålla ordet "aktiebolag" på något av följande sätt:  
&nbsp;  
- AB  
- Aktiebolag  
- Aktiebolaget  
- aktiebolag  
- aktiebolaget`,
		},
		helpText3: {
			sv: `
**Verksamhetsbeskrivning**  
Verksamheten ska vara så tydligt beskriven och avgränsad att den lätt 
kan förstås av den som vill ha information om företaget. Alltför allmänna 
beskrivningar är inte tillåtna. Det räcker inte att skriva att du ska 
bedriva handel. Du måste istället skriva vilka varor du ska handla.`,
		},
		helpText4: {
			sv: `
**Alla branscher har en SNI-kod**  
SNI-kod används till nästan all ekonomisk statistik, men även till sådant som påverkar företaget. Det kan gälla: 
- rätten till avdrag
- försäkringspremier
- kreditvärdighet
- företagsstöd
- riktad information om regeländringar i olika branscher.\n\n  
  
Läs mer om [SNI-koder hos SCB](https://snisok.scb.se/). 
`,
		},
	},
	shares: {
		title: {
			sv: "Aktier och ägande",
		},
		description: {
			sv: "Ange aktiekapital, vilka aktieägarna är och hur stora andelar ägarna kommer att ha.",
		},
		sharesHeading: {
			sv: "Aktieteckning",
		},
		sharesText: {
			sv: "Det vanligaste aktiekapitalet är 25 000 kr, men du kan välja ett högre belopp.",
		},
		shareholdersHeading: {
			sv: "Aktieägare",
		},
		distributeSharesHeading: {
			sv: "Fördelning av aktier",
		},
		distributeSharesText: {
			sv: "Fördelade aktier {0} av {1} st.",
		},
		addShareholder: {
			sv: "Lägg till aktieägare",
		},
		capital: {
			sv: "Aktiekapital",
		},
		numberOfShares: {
			sv: "Antal aktier",
		},
		sharesNumber: {
			sv: "{0} aktier",
		},
		sharePrice: {
			sv: "Pris per aktie",
		},
		pricePerShare: {
			sv: "Pris per aktie är {0} kr",
		},
		unavailableSharePrice: {
			sv: "Felaktigt antal aktier",
		},
		helpText1: {
			sv: `
**Aktieteckning**  
Ett aktiebolag behöver ett aktiekapital på minst 25 000 kronor 
för ett privat aktiebolag och minst 500 000 kronor för ett publikt aktiebolag.
`,
		},
		helpText2: {
			sv: `
**Aktieägare**  
En aktieägare deltar aktivt eller har ett bestämmande över ett företagets verksamhet, även 
om detta inte nödvändigtvis innebär att personen är formellt anställd eller sitter i 
styrelsen. I praktiken kan det handla om att en aktieägare kontrollerar en majoritet av 
rösterna eller har avtal som ger rätten att utse mer än halva styrelsen.
`,
		},
		helpText3: {
			sv: `
**Fördelning av aktier**  
Här ser du den eller de aktieägare som du har lagt till och du ska nu fylla i hur många aktier de 
ska teckna. Det är bara aktieägare som kan äga och teckna aktier.
`,
		},
		infoText: {
			sv: "Lägg till aktieägare i företaget. Som sökande är du alltid registrerad som första aktieägare. Alla	aktieägare räknas som stiftare av företaget.",
		},
		editWarning: {
			sv: "Om du lägger till eller tar bort aktieägare behöver du fylla i efterföljande steg igen.",
		},
		addShareholderModalHeading: {
			sv: "Lägg till aktieägare",
		},
		addShareholderModalText: {
			sv: "Fyll i personnummer med 12 siffror och hämta uppgifter för att påbörja registrering av aktieägare.",
		},
		editShareholderModalHeading: {
			sv: "Ändra aktieägare",
		},
		editShareholderModalText: {
			sv: "Redigera den här personen osv",
		},
		deleteShareholderModalHeading: {
			sv: "Vill du ta bort aktieägaren?",
		},
		deleteShareholderModalText: {
			sv: "Fortsätter du försvinner informationen som du angett.",
		},
		validateMinShares: { sv: "Aktieägare måste äga minst en aktie" },
		validateminCompanyShares: { sv: "Företaget måste ha aktier" },
	},
	beneficialOwnership: {
		title: {
			sv: "Verklig huvudman",
		},
		description: {
			sv: "Ange hur de verkliga huvudmännen kontrollerar företaget och i vilken omfattning.",
		},
		descriptionExtra: {
			sv: "Välj de personer som är verkliga huvudmän i företaget. Stiftare med ett större ägandeskap än 25 % blir automatiskt verkliga huvudmän.",
		},
		controlHeading: {
			sv: "Kontroll av företaget",
		},
		controlTypeHeading: {
			sv: "Art",
		},
		controlRangeHeading: {
			sv: "Omfattning",
		},
		controlRangeDescription: {
			sv: "Mer än {0}% men inte mer än {1}%",
		},
		addBeneficialOwner: {
			sv: "Lägg till verklig huvudman",
		},
		addBeneficialOwnerModalHeading: {
			sv: "Lägg till verklig huvudman",
		},
		addBeneficialOwnerModalText: {
			sv: "Fyll i personnummer med 12 siffror och hämta uppgifter för att kunna lägga till verklig huvudman.",
		},
		deleteBeneficialOwnerModalHeading: {
			sv: "Vill du ta bort verklig huvudman?",
		},
		deleteBeneficialOwnerModalText: {
			sv: "Fortsätter du försvinner informationen som du angett.",
		},
		noBeneficialOwnersWarningTitle: {
			sv: "Du behöver välja verkliga huvudmän",
		},
		noBeneficialOwnersWarningBody1: {
			sv: "Vi kan inte automatiskt fastställa någon verklig huvudman för företaget. Du behöver därför själv ange en eller flera personer som är verkliga huvudmän.",
		},
		noBeneficialOwnersWarningBody2: {
			sv: "Om ingen person är verklig huvudman ska du i stället ange en alternativ verklig huvudman. Det är vanligtvis företagets styrelseordförande, VD eller annan person med liknande befattning.",
		},
		helpText1: {
			sv: `
**Verklig huvudman**  
En verklig huvudman är den person som ytterst äger eller kontrollerar bolaget. Det är ofta en person som direkt
eller indirekt kontrollerar mer än 25 % av rösterna, men kontroll kan även utövas på andra sätt.

Du kan läsa mer om verklig huvudman hos [Bolagsverket](https://bolagsverket.se/omoss/flerverksamheter/omverklighuvudman.2539.html).
`,
		},
	},
	amlSection: {
		title: {
			sv: "Frågor för kundkännedom",
		},
		description: {
			sv: "För att vi ska ha god kundkännedom behöver du svara på var aktiekapitalet kommer ifrån.",
		},
	},
	transactionAccountSection: {
		title: {
			sv: "Transaktionskonto",
		},
		description: {
			sv: "Frågor om hur ditt företag planerar att använda kontot.",
		},
	},
	savingsAccountSection: {
		title: {
			sv: "Sparkonto",
		},
		description: {
			sv: "Frågor om hur ditt företag planerar att använda kontot.",
		},
	},
	pepSection: {
		title: {
			sv: "Frågor om verklig huvudman",
		},
		description: {
			sv: "Frågor som rör verklig huvudman i företaget.",
		},
	},
	agreement: {
		title: {
			sv: "Skriv under och skicka in",
		},
		description: {
			sv: "Granska dina uppgifter och gör eventuella ändringar innan du skriver på avtalet och på samma gång skickar in ansökan.",
		},
		sign: {
			sv: "Skriv under och skicka in",
		},
		agreementHeading: {
			sv: "Kundavtal",
		},
		successModalHeading: {
			sv: "Tack för din ansökan!",
		},
		successModalNoticeTitle: {
			sv: "Din ansökan om att starta företag är nu inskickad.",
		},
		successModalNoticeText: {
			sv: "Vi handlägger din ansökan och återkommer när det är dags att betala in aktiekapitalet och avgift för bankintyg.",
		},

		packageAndCardsHeading: {
			sv: "Företagspaket och extra kort",
		},
	},
	companyStructure: {
		title: {
			sv: "Bolagsstruktur",
		},
		representativesTitle: { sv: "Företrädare" },
		description: {
			sv: "Välj företrädare för företaget och ange hur styrelsen ska sättas upp.",
		},
		bodyText1: {
			sv: "Välj vilka roller aktieägarna ska ha. Här kan du också lägga till andra företrädare och deras roller i styrelsen.",
		},
		bodyText2: {
			sv: "Om styrelsen består av 1-2 personer måste det finnas minst 1 suppleant.",
		},
		applicantInfo: {
			sv: "Som sökande blir du automatiskt styrelseledamot i företaget.",
		},
		signatoryCombinationTitle: { sv: "Firmateckning" },
		addRepresentativeModalHeading: {
			sv: "Lägg till företrädare",
		},
		chooseSignatoryCombinationLabel: { sv: "Välj firmateckning" },
		signatoryCombinationOtherLabel: { sv: "Beskriv annan firmateckning" },
		representativeRoleLabel: { sv: "Roll i styrelsen" },
		removeRoleLabel: { sv: "Ta bort roll {0}" },
		addRole: { sv: "Lägg till roll i styrelsen" },
		addRepresentativeModalText: {
			sv: "Fyll i personnummer med 12 siffror och hämta uppgifter för att kunna lägga till företrädare.",
		},
		deleteRepresentativeModalHeading: {
			sv: "Vill du ta bort företrädare?",
		},
		deleteRepresentativeModalText: {
			sv: "Den information du angett kommer att försvinna.",
		},
		helpText1: {
			sv: `
**Företrädare**  
En företrädare agerar åt bolaget och representerar bolaget utåt. Rollen som företrädare 
skiljer sig åt från bolag till bolag, men vanligtvis är företrädaren ansvarig för att 
sköta bolagets dagliga verksamhet, fatta viktiga beslut och se till att allt går rätt till i verksamheten.
			`,
		},
		helpText2: {
			sv: `
**Firmateckning**  
En firmatecknare är den eller de personer som har rätt att agera juridiskt bindande 
för ett företag eller en förening genom att skriva under avtal och andra handlingar i dess namn.
			`,
		},
		incompleteBoardMembers: {
			sv: "Styrelsen måste bestå av minst tre ledamöter, alternativt minst en ledamot och en suppleant",
		},
		missingSignatoryCombination: {
			sv: "Det saknas en firmateckning",
		},
	},
	applicationQuestions: {
		title: {
			sv: "Frågor om verksamheten",
		},
		description: {
			sv: "Generella frågor om företaget och den verksamhet som kommer bedrivas.",
		},
	},

	monthlyPeriod: {
		sv: "/månad",
	},
	pricePerMonth: {
		sv: "{0} kr/månad",
	},
	priceMonth: {
		sv: " kr/månad",
	},
	priceKr: {
		sv: "{0} kr",
	},
	totalCost: {
		sv: "Totalsumma",
	},

	packages: {
		"SVEA-STARTA-BOLAG": {
			preTitle: {
				sv: "Företag",
			},
			title: {
				sv: "Bas",
			},
			targetGroup: {
				sv: "Företagspaket",
			},
			intro: {
				sv: "Med företagspaket Bas får du företagskonto, sparkonto, bankkort och bankgironummer för 149 kr/månad när du startar företag med oss.",
			},
			label: {
				sv: "Banktjänster",
			},
			terms: {
				sv: "Banktjänsterna har ingen bindningstid och du kan lägga till extra kort senare.",
			},
			debitCard: {
				sv: "Svea bankkort",
			},
			cardIncluded: {
				sv: "Ingår i Bas",
			},
			addDebitCard: {
				sv: "Lägg till Svea Bankkort",
			},
			noticeHeader: {
				sv: "",
			},
			notice: {
				sv: "När företaget är registrerat skickar vi ut kort till kortinnehavarens folkbokföringsadress inom 1 vecka.",
			},

			footer: {
				title: { sv: "Företagspaket Bas" },
			},

			debitCardInfoPopover: {
				sv: `
**Om bankkortet**
- Ett Mastercard där reseförsäkring och avbeställningsskydd ingår.
- Köp med bankkort dras direkt från företagskontot så att du har full kontroll över utgifterna.`,
			},
			debitCardDescription: {
				sv: "Ange uppgifter för det bankkort som ingår. Du kan också lägga till extra kort till personer i ditt företag. Kostnad för extra kort per månad tillkommer ({0} kr/kort).",
			},

			summary: {
				title: { sv: "Företagspaket Bas" },
				packageMonthlyCost: {
					sv: "Bas {0} kr/mån",
				},
				extraDebitCards: {
					sv: "Extra Svea Bankkort",
				},
				extraDebitCardsTotalCost: {
					sv: "Extra Svea Bankkort {0} kr/mån",
				},
				packageProductBullets: {
					sv: `
- Svea Bankkort
- Företagskonto
- Sparkonto med ränta
- Bankgironummer
`,
				},
			},

			desktop: {
				description: {
					sv: "De viktigaste banktjänsterna för startup och egenföretagare till ett bra pris. Företagskontot kopplas till ett bankkort och ett nytt eller befintligt bankgironummer.",
				},
				bullet1: {
					sv: "Svea Bankkort",
				},
				bullet2: {
					sv: "Sparkonto med ränta",
				},
				bullet3: {
					sv: "Företagskonto",
				},
				bullet4: {
					sv: "Bankgironummer",
				},
			},
			mobile: {
				description: {
					sv: "De viktigaste banktjänsterna för startup och egenföretagare till ett bra pris.",
				},
				bullet1: {
					sv: "Svea bankkort",
				},
				bullet2: {
					sv: "Företagskonto",
				},
				bullet3: {
					sv: "Sparkonto med ränta",
				},
			},

			externalLink: {
				sv: "https://www.svea.com/sv-se/foretag/f%C3%B6retagsbanken/f%C3%B6retag-bas",
			},
			promo: {
				sv: "Passar småföretagare",
			},
			promoMobile: {
				sv: "Småföretagare",
			},
		},

		"FÖRETAGARNA-SVEA-STARTA-BOLAG": {
			preTitle: {
				sv: "Företagarna",
			},
			label: {
				sv: "Medlemskap och banktjänster",
			},
			title: {
				sv: "Bas",
			},
			postTitle: {
				sv: " + medlemskap i Företagarna",
			},
			targetGroup: {
				sv: "Företagspaket",
			},
			moreAbout: {
				sv: "Mer om Svea och Företagarna",
			},

			discount: {
				sv: "Rabatt första året",
			},

			terms: {
				sv: "Banktjänsterna har ingen bindningstid och du kan lägga till extra kort senare.",
			},
			debitCard: {
				sv: "Företagarna bankkort",
			},
			noticeHeader: {
				sv: "Kort och medlemskap",
			},
			notice: {
				sv: "När företaget är registrerat skickar vi ut kort till kortinnehavarens folkbokföringsadress inom 1 vecka. Företagarna skickar faktura för medlemskapet separat.",
			},
			checkboxLabel: {
				sv: "Jag samtycker till att Svea Bank delar uppgifterna i denna ansökan med Företagarna för att hantera och registrera min medlemsansökan samt godkänner [Företagarnas medlemsvillkor](https://www.foretagarna.se/teckna-medlemskap/villkor/)",
			},
			consentRequired: {
				sv: "Du måste godkänna delning av uppgifter för att kunna ansöka om medlemskap i Företagarna.",
			},
			cardIncluded: {
				sv: "Ingår i Företagarna",
			},
			addDebitCard: {
				sv: "Lägg till Företagarna bankkort",
			},
			monthlyPeriod: {
				sv: "/månad",
			},

			chooseHeading: {
				sv: "Paket med banktjänster",
			},
			logoAlt: {
				sv: "Företagarna Logo",
			},
			cardImageAlt: {
				sv: "Företagarna bankkort",
			},

			offer: {
				label: {
					sv: "Rabatt första året",
				},
				question: {
					sv: "Vill du även bli medlem i Sveriges största nätverk för företagare?",
				},
				yesOption: {
					sv: "Ja, lägg till 1 års medlemskap i Företagarna",
				},
				noOption: {
					sv: "Nej, fortsätt med enbart banktjänsterna",
				},
				membershipHeading: {
					sv: "Årsmedlemskap i Företagarna och förmånligt bankkort",
				},
				membershipDescription: {
					sv: "Som medlem får du fri juridisk telefonrådgivning, medlemsförmåner som hjälper dig att sänka dina kostnader, möjlighet att teckna försäkringar, inbjudningar till events och tillgång till ett starkt nätverk för företagare i Sverige.",
				},
			},

			estimatedCost: {
				sv: "* Beräknad kostnad som Företagarna fakturerar årsvis: Medlemskap 600 kr/år och rabatterad serviceavgift det första året 875 kr (ordinarie 1 250 kr/år). Banktjänsterna kostar 149 kr/månad och har ingen bindningstid.",
			},
			aboutHeading: {
				sv: "Mer om Företagarna",
			},
			aboutDescription: {
				sv: "Företagarna är Sveriges största företagarorganisation och arbetar för att skapa bättre förutsättningar för företagare att starta, driva och utveckla företag i Sverige.",
			},
			memberBenefitsIntro: {
				sv: "Som medlem får du bland annat tillgång till:",
			},
			memberBenefit1: {
				sv: "Medlemsförmåner",
			},
			memberBenefit2: {
				sv: "Juridisk telefonrådgivning",
			},
			memberBenefit3: {
				sv: "Kunskap och stöd",
			},
			memberBenefit4: {
				sv: "Event och nätverk",
			},
			memberBenefit5: {
				sv: "Företagsanpassade försäkringar",
			},
			membershipLinkText: {
				sv: "Läs mer om medlemskapet",
			},
			debitCardInfoPopover: {
				sv: `
**Företagarna Bankkort**  
Med Företagarna Bankkort gör du köp som dras direkt från företagets konto. På så sätt kan du enkelt 
göra både små och stora köp för företagets räkning och hålla full koll på utläggen. 
`,
			},
			debitCardDescription: {
				sv: "Ange uppgifter för det bankkort som ingår. Du kan också lägga till extra kort till personer i ditt företag. Kostnad för extra kort per månad tillkommer ({0} kr/kort).",
			},

			summary: {
				title: { sv: "Företagarna medlemskapet" },
				packageMonthlyCost: {
					sv: "Bas + medlemskap {0} kr/mån",
				},
				extraDebitCards: {
					sv: "Extra Företagarna Bankkort",
				},
				extraDebitCardsTotalCost: {
					sv: "Extra Företagarna Bankkort {0} kr/mån",
				},
				packageProductBullets: {
					sv: `
- Företagarna bankkort
- Företagskonto
- Sparkonto med ränta
- Bankgironummer
- Medlemskap i Företagarna
`,
				},
			},

			desktop: {
				description: {
					sv: "De viktigaste banktjänsterna för startup och egenföretagare till ett bra pris. Företagskontot kopplas till Företagarnas förmånliga bankkort och ett nytt eller befintligt bankgironummer.",
				},
				bullet1: {
					sv: "Företagarna bankkort",
				},
				bullet2: {
					sv: "Sparkonto med ränta",
				},
				bullet3: {
					sv: "Företagskonto",
				},
				bullet4: {
					sv: "Bankgironummer",
				},
				bullet5: {
					sv: "Medlemsförmåner på kortet",
				},
			},
			mobile: {
				description: {
					sv: "",
				},
				bullet1: {
					sv: "Företagarna bankkort",
				},
				bullet2: {
					sv: "Företagskonto",
				},
				bullet3: {
					sv: "Sparkonto med ränta",
				},
			},

			externalLink: {
				sv: "https://www.foretagarna.se/medlemsformaner/ekonomi/svea-bank/svea-medlemskap",
			},

			footer: {
				title: { sv: "Företagspaket Bas" },
				membership: {
					sv: "Årsmedlemskap Företagarna",
				},
				total: {
					sv: "Totalt",
				},
				membershipPopover: {
					sv: `
**Årsmedlemskap Företagarna**  
Företagarna fakturerar årsvis och den motsvarande månadskostnaden blir 123 kr.

- Medlemsavgift 600 kr/år
- Rabatterad serviceavgift det första året 875 kr (ordinarie pris 1 250 kr/år)

Medlemskapet är kopplat både till dig som person och ditt företag.
`,
				},
			},
		},
	},

	products: {
		productsHeading: {
			sv: "Företagspaket och kort",
		},
		productsDescription: {
			sv: "Banktjänster som används när du startar ditt nya företag. Lägg till eventuella extra kort och medlemskap i Företagarna.",
		},

		basePackageSubheading: {
			sv: "Vårt paket när du startar företag",
		},
		basePackageInfoBox: {
			sv: `
- Företagskonto
- Svea Bankkort
- Sparkonto med ränta
- Bankgironummer  
  
När du blivit kund kan du när som helst uppgradera ditt paket med våra tilläggstjänster.
			`,
		},

		cardDisplayNameMissing: {
			sv: "Namn saknas",
		},
		selectDisplayName: {
			sv: "Välj namn på kortet",
		},
		configCardModalHeading: {
			sv: "Kortuppgifter",
		},
		configCardModalText1: {
			sv: "Här ser du de namnkombinationer som ryms på kortet. Du kan bara välja ett alternativ.",
		},
		configCardModalText2: {
			sv: "Pinkod väljs av kortinnehavaren när kortet aktiveras i Internetbanken.",
		},
		configCardEmailNotUnique: {
			sv: "Mejladressen används redan av en annan kortinnehavare",
		},
		unconfiguredCardError: {
			sv: "Du måste ange namn på ditt kort",
		},
	},
	payment: {
		paymentHeading: {
			sv: "Betala in aktiekapital",
		},
		paymentDescription: {
			sv: "Betala in aktiekapitalet och avgiften för bankintyget. Du får en bekräftelse när betalningen är genomförd.",
		},
		successModalHeading: {
			sv: "Din betalning är klar!",
		},
		successModalNoticeTitle: {
			sv: "Vi har tagit emot din betalning för aktiekapital och avgift för bankintyg",
		},
		successModalNoticeText: {
			sv: "Vi kommer skapa upp ditt bankintyg och skicka det till Bolagsverket. Du kommer nu loggas ut men du kan följa status på din ansökan genom att logga in igen.",
		},
		successModalButtonText: {
			sv: "Okej, logga ut mig",
		},
	},
	cancelModal: {
		heading: {
			sv: "Vill du avbryta din ansökan och fortsätta senare?",
		},
		text: {
			sv: "Den information du precis angett kommer att försvinna. Din ansökan sparas från och med föregående steg och du kan fortsätta senare.",
		},
		cancelButtonText: {
			sv: "Avbryt ansökan",
		},
		continueButtonText: {
			sv: "Fortsätt ansöka ",
		},
	},
	deleteModal: {
		heading: {
			sv: "Vill du ta bort din ansökan?",
		},
		text: {
			sv: "Den information du angett kommer att försvinna och din ansökan tas bort.",
		},
		deleteButtonText: {
			sv: "Ta bort ansökan",
		},
		closeButtonText: {
			sv: "Avbryt",
		},
	},
	paymentRemainderModal: {
		heading: {
			sv: "Betala in aktiekapitalet till ditt nya företag",
		},
		text: {
			sv: "När du har betalat in aktiekapitalet skapar vi ditt bankintyg och skickar det till Bolagsverket.",
		},
		primaryButtonText: {
			sv: "Betala in aktiekapital",
		},
	},
	ongoing: {
		status: {
			sv: "Ansökan påbörjad",
		},
		description: {
			sv: "Fortsätt ansöka för att komma till nästa steg i starta företag.",
		},
	},
	inReview: {
		status: {
			sv: "Ansökan inskickad",
		},
		description: {
			sv: "Vi kontaktar dig när det är dags för betalning av aktiekapital och avgift för bankintyg.",
		},
	},
	awaitingPayment: {
		status: {
			sv: "Väntar på betalning från dig",
		},
		description: {
			sv: "Du behöver betala in aktiekapital och avgift för bankintyg för ditt företag.",
		},
	},
	paymentCompleted: {
		status: {
			sv: "Betalning för aktiekapital mottagen",
		},
		description: {
			sv: "Vi handlägger nu din ansökan och skapar ditt bankintyg som skickas till Bolagsverket.",
		},
	},
	awaitingOrgNumber: {
		status: {
			sv: "Väntar på uppgifter om ditt företag",
		},
		description: {
			sv: "När vi fått uppgifterna behöver du bekräfta att de överensstämmer med företaget du vill starta hos oss.",
		},
	},
	orgNumberSet: {
		status: {
			sv: "Företagsuppgifter bekräftade",
		},
		description: {
			sv: "Nu förbereder vi ditt företagskonto. När det är klart för vi över ditt aktiekapital till kontot.",
		},
	},
	setOrgNumber: {
		heading: {
			sv: "Bekräfta uppgifter för start av företag",
		},
		text: {
			sv: "Vi har fått företagsuppgifter från Bolagsverket och behöver din bekräftelse att uppgifterna överensstämmer med det företag du ansökt om att starta hos oss.",
		},
		companyName: {
			sv: "Företagsnamn",
		},
		organisationNumber: {
			sv: "Organisationsnummer",
		},
		registrationDate: {
			sv: "Registrering på Bolagsverket",
		},
		primaryButtonText: {
			sv: "Ja",
		},
		secondaryButtonText: {
			sv: "Nej",
		},
		successModalNoticeTitle: {
			sv: "Uppgifterna kring ditt nyskapade företag är nu bekräftade",
		},
		successModalNoticeText: {
			sv: "Nu dubbelkollar vi alla uppgifter. Du kan följa din ansökan på startsidan. När allt är klart kan du börja använda tjänsterna direkt - som företagskund i Svea Bank.",
		},
	},
	noClcCandidate: {
		heading: {
			sv: "Vi hittade inga företag",
		},
		text: {
			sv: "Vi väntar på uppgifter från Bolagsverket gällande det företag som du vill starta hos oss. När vi fått uppgifterna behöver du bekräfta dem. Har du frågor kan du kontakta vår kundtjänst på 08-616 99 00.",
		},
		buttonText: {
			sv: "Okej",
		},
	},
	chooseClcCompany: {
		heading: {
			sv: "Välj företag",
		},
		text: {
			sv: "De här företagen har du registrerat på Bolagsverket de senaste 6 månaderna. Välj vilka uppgifter som överensstämmer med det företag du vill starta hos oss.",
		},
		buttonText: {
			sv: "Välj företag",
		},
	},
};
